var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconFeedsTab = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28125 13.75H8.125L7.92188 15.0938H7.14062C6.71094 15.0938 6.35938 15.4531 6.35938 15.875C6.35938 16.2891 6.71094 16.6484 7.14062 16.6484H14.1172C14.5547 16.6484 14.8984 16.2891 14.8984 15.875C14.8984 15.4531 14.5547 15.0938 14.1172 15.0938H13.3359L13.1406 13.75H17.9766C19.4688 13.75 20.2734 12.9766 20.2734 11.4609V2.40625C20.2734 0.890625 19.4688 0.117188 17.9766 0.117188H3.28125C1.78906 0.117188 0.992188 0.890625 0.992188 2.40625V11.4609C0.992188 12.9766 1.78906 13.75 3.28125 13.75ZM3.03906 9.97656C2.82031 9.97656 2.71875 9.89062 2.71875 9.65625V2.5625C2.71875 2.03906 2.94531 1.83594 3.4375 1.83594H17.8203C18.3203 1.83594 18.5469 2.03906 18.5469 2.5625V9.65625C18.5469 9.89062 18.4453 9.97656 18.2266 9.97656H3.03906ZM10.6328 12.9531C10.1875 12.9531 9.82812 12.5938 9.82812 12.1562C9.82812 11.7188 10.1875 11.3516 10.6328 11.3516C11.0703 11.3516 11.4297 11.7188 11.4297 12.1562C11.4297 12.5938 11.0703 12.9531 10.6328 12.9531Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconFeedsTab);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-feeds-tab.34c4f050b82eb02fe6250f95c9919ce8.svg";